// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Layout Layout Matrix */
.manage-server-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header Section Integration */
.manage-server-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.manage-server-header h2 {
  margin: 0;
  font-size: 24px;
  color: #1e293b;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.manage-server-header p {
  margin: 4px 0 0 0;
  color: #64748b;
  font-size: 14px;
}

/* Add Server Button Professional Palette */
.manage-server-add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  background-color: #0f172a;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  white-space: nowrap;
}

.manage-server-add-btn:hover {
  background-color: #1e293b;
}

.manage-server-add-btn:active {
  transform: scale(0.98);
}

/* Loading & Spinner Architecture */
.manage-server-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
  color: #64748b;
  font-size: 14px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.manage-server-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f1f5f9;
  border-top: 3px solid #0f172a;
  border-radius: 50%;
  animation: server-spin 0.8s linear infinite;
}

@keyframes server-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Table Shell Wrapper */
.manage-server-table-wrapper {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  overflow-x: auto; /* স্ক্রিন ছোট হলে টেবিল যেন স্ক্রল হয় */
  width: 100%;
}

/* Core Infrastructure Pro Table */
.manage-server-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
  color: #334155;
  min-width: 700px; /* মোবাইল স্ক্রিনে ডেটা ভেঙে নিচে না যাওয়ার সিকিউরিটি */
}

.manage-server-table th {
  background-color: #f8fafc;
  padding: 14px 16px;
  font-weight: 700;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.manage-server-table tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}

.manage-server-table tr:hover {
  background-color: #f8fafc;
}

.manage-server-table tr:last-child {
  border-bottom: none;
}

.manage-server-table td {
  padding: 16px;
  vertical-align: middle;
}

/* Empty Registry Handler UI */
.manage-server-empty {
  text-align: center;
  padding: 40px !important;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

/* Bottom Action Layout for Back Button */
.manage-server-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  color: #334155;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.manage-server-back-btn:hover {
  background-color: #f8fafc;
  border-color: #94a3b8;
}

/* ==========================================================================
   📱 Mobile Responsive Breakpoints For Smooth Rendering
   ========================================================================== */
@media (max-width: 640px) {
  .manage-server-container {
    padding: 16px;
  }

  .manage-server-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .manage-server-add-btn {
    width: 100%;
    justify-content: center;
    padding: 12px;
  }

  .manage-server-header h2 {
    font-size: 20px;
  }
  
  /* মোবাইলে স্ক্রলবার ট্র্যাকিং ইন্ডিকেটর হাল্কা করার জন্য */
  .manage-server-table-wrapper {
    -webkit-overflow-scrolling: touch;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Server/ManageServer.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,gGAAgG;EAChG,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB,EAAE,wCAAwC;EAC1D,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,2DAA2D;EAC3D;IACE,iCAAiC;EACnC;AACF","sourcesContent":["/* Container Layout Layout Matrix */\n.manage-server-container {\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header Section Integration */\n.manage-server-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.manage-server-header h2 {\n  margin: 0;\n  font-size: 24px;\n  color: #1e293b;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.manage-server-header p {\n  margin: 4px 0 0 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Add Server Button Professional Palette */\n.manage-server-add-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 6px;\n  border: none;\n  background-color: #0f172a;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n  white-space: nowrap;\n}\n\n.manage-server-add-btn:hover {\n  background-color: #1e293b;\n}\n\n.manage-server-add-btn:active {\n  transform: scale(0.98);\n}\n\n/* Loading & Spinner Architecture */\n.manage-server-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 16px;\n  color: #64748b;\n  font-size: 14px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.manage-server-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f1f5f9;\n  border-top: 3px solid #0f172a;\n  border-radius: 50%;\n  animation: server-spin 0.8s linear infinite;\n}\n\n@keyframes server-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive Table Shell Wrapper */\n.manage-server-table-wrapper {\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  overflow-x: auto; /* স্ক্রিন ছোট হলে টেবিল যেন স্ক্রল হয় */\n  width: 100%;\n}\n\n/* Core Infrastructure Pro Table */\n.manage-server-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 14px;\n  color: #334155;\n  min-width: 700px; /* মোবাইল স্ক্রিনে ডেটা ভেঙে নিচে না যাওয়ার সিকিউরিটি */\n}\n\n.manage-server-table th {\n  background-color: #f8fafc;\n  padding: 14px 16px;\n  font-weight: 700;\n  color: #475569;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.manage-server-table tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background-color 0.15s ease;\n}\n\n.manage-server-table tr:hover {\n  background-color: #f8fafc;\n}\n\n.manage-server-table tr:last-child {\n  border-bottom: none;\n}\n\n.manage-server-table td {\n  padding: 16px;\n  vertical-align: middle;\n}\n\n/* Empty Registry Handler UI */\n.manage-server-empty {\n  text-align: center;\n  padding: 40px !important;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Bottom Action Layout for Back Button */\n.manage-server-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  color: #334155;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.manage-server-back-btn:hover {\n  background-color: #f8fafc;\n  border-color: #94a3b8;\n}\n\n/* ==========================================================================\n   📱 Mobile Responsive Breakpoints For Smooth Rendering\n   ========================================================================== */\n@media (max-width: 640px) {\n  .manage-server-container {\n    padding: 16px;\n  }\n\n  .manage-server-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .manage-server-add-btn {\n    width: 100%;\n    justify-content: center;\n    padding: 12px;\n  }\n\n  .manage-server-header h2 {\n    font-size: 20px;\n  }\n  \n  /* মোবাইলে স্ক্রলবার ট্র্যাকিং ইন্ডিকেটর হাল্কা করার জন্য */\n  .manage-server-table-wrapper {\n    -webkit-overflow-scrolling: touch;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
